import 'styles/generic/customers/customerLogos.less';

import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { useGeoLocalizedCustomerLogos } from './useGeoLocalizedCustomerLogos';
import Slider from 'react-slick';

export const CustomerLogos = ({ style, slidesToShow, useGlobalLogos, hideText }) => {
    const { geoLocalizedLogos } = useGeoLocalizedCustomerLogos(useGlobalLogos);
    const logos = geoLocalizedLogos;

    const settings = {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        infinite: true,
        fadeIn: true,
        pauseOnHover: false,
        slidesToShow: slidesToShow ? slidesToShow : 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    return (
        <div className="w-100 h-100 flex itemsCenter justifyCenter" style={style}>
            <div className="tac customerLogos" style={{ width: '100%', marginBottom: 0 }}>
                <div className="inner dib">
                    {!hideText ? (
                        <p style={{ margin: '0px' }}>Trusted by top sales teams globally</p>
                    ) : null}
                    {logos ? (
                        <div className="logos flex itemsCenter justifyCenter">
                            <Slider {...settings} style={{ width: '100%', height: 'auto' }}>
                                {logos.map((logo, index) => {
                                    const { image, description } = logo;
                                    return (
                                        <div key={index} className="logoWrapper">
                                            <div className="innerLogoWrapper">
                                                <GatsbyImage
                                                    image={image.asset.gatsbyImageData}
                                                    alt={description}
                                                    className="w-100 h-100"
                                                    imgStyle={{ objectFit: 'contain' }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </Slider>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
